// 这个存放纯工具函数，不可引入vuex等和业务相关的module
// 已经不纯了 ----2023/04/10

import appCode from "./app-code";
import VueRouter from "vue-router";
import { moneyFormat } from "./tools";
import dayjs from "dayjs";
/**
 * 千位分割
 * @param {number | string} num
 * @return {string}
 */
export function splitThousands(num) {
  return moneyFormat(num, true);
}

/**
 * 除了0 所有能转换为false的都用“-”代替
 * @param {number} val 目标值
 * @param {number} showValue  val格式化后的值
 * @return {string}
 */
export function emptyToLine(val, showValue?) {
  return val || val === 0 ? (showValue ? (typeof showValue === "function" ? showValue() : showValue) : val) : "-";
}

/**
 * 生成uuid
 * @param {number} len 长度
 * @param {number} radix 基数(范围)
 * @return {string}
 */
export function getUuid(len, radix?) {
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  let uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}

/**
 * 8位日期格式化 20200508 => 2020-05-08
 * @param {number} date 日期
 * @return {string}
 */
export function numDateToDate(date) {
  if (!date) {
    return "-";
  }
  return date.substr(0, 4) + "-" + date.substr(4, 2) + "-" + date.substr(6, 2);
}

/**
 * 获取图片的高度和宽度
 * @param {Element} imgEl
 * @return {Array} [width, height]
 */
export function getImageSize(imgEl) {
  let width: number = 0,
    height: number = 0;
  height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
  width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;
  return [width, height];
}

// 根据url获取文件类型
export const getMediaType = url => {
  const imageFormat = ["png", "jpg", "jpge", "ico", "bmp", "gif", "tif", "pcx", "tga"];
  const videoFormat = ["mp4", "avi", "mp4", "avi", "3gp", "rmvb", "wav", "mpg", "mkv", "vob", "mov", "flv", "swf"];
  let arr = url.split(".");
  let type = arr[arr.length - 1];
  if (imageFormat.includes(type.toLowerCase())) {
    return "image";
  } else if (videoFormat.includes(type.toLowerCase())) {
    return "video";
  } else {
    return new Error("not image or video file");
  }
};

// 安全获取对象属性
export function safeValue(obj, keyStr, placeholder: any = undefined) {
  if (!obj) return placeholder;
  const keyArr = keyStr.split(".");
  let curValue = obj;
  for (let i = 0; i < keyArr.length; i++) {
    let temp = curValue[keyArr[i]];
    if (!temp) {
      console.warn(keyStr + " of undefined");
      return placeholder;
    }
    curValue = temp;
  }
  return curValue;
}

// 获取文件类型后缀
export const getFileUrlSuffix = url => {
  try {
    let temArr = url.split(".");
    return temArr[temArr.length - 1].toLowerCase();
  } catch (e) {
    return null;
  }
};

// editorAllowImage
export const isEditorAllowImage = url => {
  return getFileUrlSuffix(url) === "jpg" || getFileUrlSuffix(url) === "png" || getFileUrlSuffix(url) === "jpge";
};

/**
 * @param menuList apiData
 * @returns [{resourceCode:path}]
 */
export function getMenuPathResourceCodeMap(menuList) {
  let tempMap = {};
  function _get(arr) {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (item.pageUrl) {
        tempMap[item.resourceCode] = item.pageUrl;
      }
      if (item.children) {
        _get(item.children);
      }
    }
  }
  _get(menuList);
  return tempMap;
}

/**
 * 针对common页面相同的按钮不同的path跳转
 * @param pathMap {speedbiz:/xxx/xx,speedbiz-operation:/xxx/xxx}
 * @param router Vue $router
 */
const vueRouter = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL
});
export function commonRouterPush(pathMap, itJump = false, router?) {
  if (itJump) {
    (router || vueRouter).push(pathMap[appCode] || "");
  }
  return pathMap[appCode] || "";
}

// 获取时区 如 +0800
export function getTimezone() {
  const diffMinus = new Date().getTimezoneOffset();
  const zoneNum = -diffMinus / 60;
  const zoneMinusNum = Math.abs(diffMinus % 60);
  const symbol = zoneNum >= 0 ? "+" : "-";
  const zoneNumAbs = Math.floor(Math.abs(zoneNum));
  let str = "";
  if (zoneNumAbs >= 10) {
    str = `${symbol}${zoneNumAbs}${zoneMinusNum > 0 ? zoneMinusNum : "00"}`;
  } else {
    str = `${symbol}0${zoneNumAbs}${zoneMinusNum > 0 ? zoneMinusNum : "00"}`;
  }
  if (str.length !== 5) {
    str = "+0800";
  }
  return str;
}

/**
 * 安全获取本地存储里的json字符串
 * @param storageKey 本地存储的key
 * @param defaultValue 解析失败后返回的默认值
 * @returns json
 */
export function safeGetStorage(storageKey, defaultValue) {
  const value = localStorage.getItem(storageKey);
  const defaultValueIsString = typeof defaultValue === "string";
  try {
    if (value && value !== "undefined") {
      return JSON.parse(value);
    } else {
      localStorage.setItem(storageKey, defaultValueIsString ? defaultValue : JSON.stringify(defaultValue));
      return defaultValue;
    }
  } catch (e) {
    return value || defaultValue;
  }
}

type getDateRangeDateKey =
  | "yesterday_to_yesterday"
  | "today_to_today"
  | "first_day_to_today_of_current_month"
  | "first_day_to_yesterday_of_current_month"
  | "current_month_to_current_month"
  | "first_month_to_current_month_of_current_year"
  | "first_month_to_last_month_of_current_year";

/**
 *  获取基于dayjs的日期或区间
 *  @param { String } dateKey  dateKey
 *  @param { String } format  dateKey
 *  @return { Date }
 */
export function getDateRange(dateKey: getDateRangeDateKey): Date[];
export function getDateRange(dateKey: getDateRangeDateKey, format: string): string[];
export function getDateRange(dateKey: getDateRangeDateKey, format?: string): (string | Date)[] {
  const dateFunc = {
    yesterday_to_yesterday: () => {
      return [dayjs().subtract(1, "day").toDate(), dayjs().subtract(1, "day").toDate()];
    },
    today_to_today: () => {
      return [dayjs().toDate(), dayjs().toDate()];
    },
    first_day_to_today_of_current_month: () => {
      return [dayjs().startOf("month").toDate(), dayjs().toDate()];
    },
    first_day_to_yesterday_of_current_month: () => {
      if (dayjs().get("date") === 1) {
        return [
          dayjs().subtract(1, "month").startOf("month").toDate(),
          dayjs().subtract(1, "month").endOf("month").toDate()
        ];
      } else {
        return [dayjs().startOf("month").toDate(), dayjs().subtract(1, "day").toDate()];
      }
    },
    current_month_to_current_month: () => {
      return [dayjs().toDate(), dayjs().toDate()];
    },
    first_month_to_current_month_of_current_year: () => {
      return [dayjs().startOf("year").toDate(), dayjs().toDate()];
    },
    first_month_to_last_month_of_current_year: () => {
      if (dayjs().get("month") === 1) {
        return [
          dayjs().subtract(1, "year").startOf("year").toDate(),
          dayjs().subtract(1, "year").endOf("year").toDate()
        ];
      } else {
        return [dayjs().startOf("year").toDate(), dayjs().subtract(1, "month").endOf("month").toDate()];
      }
    }
  };
  if (format) {
    return dateFunc[dateKey]().map(date => dayjs(date).format(format));
  } else {
    return dateFunc[dateKey]();
  }
}

/**
 * 时间转换 ISO时间格式转换到天或小时
 * @param iso str
 * @param formatType // date：天 time：具体到时分秒
 * @returns format str
 */
export function isoDateFormat(isoStr, formatType = "date") {
  if (!isoStr) return "-";
  if (formatType === "date") {
    return dayjs(isoStr).format("YYYY-MM-DD");
  } else {
    return dayjs(isoStr).format("YYYY-MM-DD HH:mm:ss");
  }
}
